import * as format from 'string-format';

class StringUtils {
  public static format(strFormat: string, ...args): string {
    return format(strFormat, ...args);
  }
}

export default StringUtils;
